import * as _ from 'lodash-es';

export function getBytesToSize(size: any, decimals: number = 0) {
                
    decimals = decimals || 0;

    if (size == "" || isNaN(size)) {
        return '';
    }

    if (size < 1024)
        return size + ' b';

    size /= 1024;

    if (size < 1024)
        return size.toFixed(decimals) + ' KB';

    size /= 1024;

    if (size < 1024)
        return size.toFixed(decimals) + ' MB';

    size /= 1024;

    if (size < 1024)
        return size.toFixed(decimals) + ' GB';

    size /= 1024;

    return size.toFixed(decimals) + ' TB';
};

export function coalesceFilter(target, fieldName, defaultValue, splitterValue) {

    if (splitterValue === undefined || splitterValue === null) {
        splitterValue = '';
    }
    return splitterValue + _.get(target, fieldName, defaultValue);
};

export function gfBoolFilter(inputValue) {
    return ['true', true, 'Y', 'y'].includes(inputValue);
};